"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const _1 = require("../.");
/**
 * A list of options, where user can pick only one.
 */
const Radio = ({ name, value, mandatory, small, setValue, options, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", null, options.map((option, index) => {
        const { optionLabel, optionValue } = (0, _1.parseOption)(option);
        return (react_1.default.createElement("label", { className: (0, classnames_1.default)(classes.label, 'rfc-checkitem', { [classes.small]: small }), key: index, htmlFor: `${name}${index}` },
            react_1.default.createElement("input", { type: 'radio', name: name, value: optionValue, className: classes.input, id: `${name}${index}`, checked: optionValue === value, onChange: (e) => setValue(name, e.target.value, mandatory, { touched: true }) }),
            " ",
            optionLabel));
    })));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => {
    const inputSize = 18;
    return {
        label: {
            display: 'flex',
            cursor: 'pointer',
            minHeight: inputSize + 2,
        },
        input: {
            margin: '0 10px 0 0',
            position: 'relative',
            outline: 'none',
            transform: (0, _1.calculateInputTranslation)(theme.typography.inputFontSize, inputSize),
            minWidth: inputSize,
            '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                boxSizing: 'border-box',
                width: inputSize,
                height: inputSize,
                verticalAlign: 'baseline',
                top: 0,
                left: 0,
                backgroundColor: theme.colors.inputBg !== 'transparent' ? theme.colors.inputBg : 'white',
                cursor: 'pointer',
                border: `2px solid ${theme.colors.inputBorder}`,
                borderRadius: '50%',
            },
            '&:checked': {
                '&::before': {
                    borderColor: theme.colors.accent,
                },
                '&::after': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    width: inputSize - 8,
                    height: inputSize - 8,
                    top: 4,
                    left: 4,
                    backgroundColor: theme.colors.accent,
                    cursor: 'pointer',
                    borderRadius: '50%',
                },
            },
        },
        small: {
            fontSize: `${theme.typography.inputFontSize - 4}px !important`,
            '& $input': {
                transform: (0, _1.calculateInputTranslation)(theme.typography.inputFontSize - 4, inputSize),
            },
        },
    };
});
exports.default = (0, _1.withFormControl)(Radio);
